import { render } from "./Pagination.vue?vue&type=template&id=483297b9&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=483297b9&lang=scss&scoped=true"

import exportComponent from "D:\\ZAHB\\live-sdk-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483297b9"]])

export default __exports__